// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.upLoad-button[data-v-77309e9c] {\n    position: relative;\n    padding: 5px;\n}\n.fake[data-v-77309e9c] {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    left: 0;\n    height: 100%;\n    text-align: center;\n    vertical-align: middle;\n    padding-top: 7px;\n    z-index: 1;\n}\n.file[data-v-77309e9c] {\n    position: relative;\n    /*text-align: right;*/\n    -moz-opacity: 0;\n    filter: alpha(opacity:0);\n    opacity: 0;\n    z-index: 2;\n}\n", ""]);
// Exports
module.exports = exports;
